import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component
import { devConfig } from 'config/config'; // Import development configuration

/**
 * ConfigurationBestShopView class extends JetView to create a specific view.
 */
export default class configurationBestShopView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        return {
            type: 'wide', // Layout type
            cols: [
                {
                    localId: 'inner:layout', // Local ID for the layout
                    type: 'wide', // Layout type
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Local ID for the tab bar
                            height: 43, // Height of the tab bar
                            options: [
                                {
                                    id: 'betShopManagement.configuration.changePassword', // Tab ID
                                    value: _('Cambiar Contraseña'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'betShopManagementConfigurationChangePasswordMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagementConfigurationChangePasswordMenu', // CSS class
                                },
                                {
                                    id: 'betShopManagement.configuration.generateToken', // Tab ID
                                    value: _('Generar Token'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'betShopManagementConfigurationGenerateTokenMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagementConfigurationGenerateTokenMenu', // CSS class
                                },
                                {
                                    id: 'betShopManagement.configuration.securityChanges', // Tab ID
                                    value: _('Seguridad Cambios'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'betShopManagementConfigurationSecurityChangesMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagementConfigurationSecurityChangesMenu', // CSS class
                                },
                                {
                                    id: 'betShopManagement.configuration.qrgoogle', // Tab ID
                                    value: _('QR Google'), // Tab label
                                    hidden: !devConfig.getPermAction(
                                        // Visibility based on permissions
                                        'betShopManagementConfigurationQrgoogleMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-betShopManagementConfigurationQrgoogleMenu', // CSS class
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subviews
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            // Wait for Webix to be ready
            webix.attachEvent('onRotate', function (orientation) {
                // Attach event for orientation change
                window.location.reload(); // Reload the page on orientation change
            });
        });
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter
        );
    }
}

// FILE DOCUMENTED
